module.exports = __webpack_public_path__ + "img/barUnfilledLarge.838cbd44.svg";